import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc-app/design-system';

interface IProps {
  label: string;
  value?: any;
}

// TODO: remove later
export const FormReadOnly: React.FC<IProps> = ({ label, value }) => (
  <Box mb={4}>
    <Typography variant='body2' gutterBottom>
      {label}
    </Typography>
    <Typography paragraph>{value}</Typography>
  </Box>
);
